<div class="layout">
  <ng-container>
    <router-outlet></router-outlet>
  </ng-container>
</div>
